import { resources } from '@/mocks/resources';
import ResourceCard from '@/components/feature/ResourceCard';

export default function HotResources() {
  const hotResources = resources.filter((r) => r.featured);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3 font-heading">
            热门推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            大家最爱的精选资源，下载量高、好评不断
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {hotResources.map((res, index) => (
            <div
              key={res.id}
              className="animate-fade-in-up"
              style={{ animationDelay: `${index * 0.12}s` }}
            >
              <ResourceCard resource={res} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}